import { render, staticRenderFns } from "./DiscoverRealTimeWordsFrequencyTable.vue?vue&type=template&id=32effd9a&scoped=true&"
import script from "./DiscoverRealTimeWordsFrequencyTable.vue?vue&type=script&lang=js&"
export * from "./DiscoverRealTimeWordsFrequencyTable.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverRealTimeWordsFrequencyTable.vue?vue&type=style&index=0&id=32effd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32effd9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
